import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import './styles/styles.scss';
import HomePage from './pages/home';
import { Route, Switch, HashRouter, useLocation } from 'react-router-dom';
import StateSelectionPage from './pages/state-selection';
import ResultsPage from './pages/results';
import ProfilePage from './pages/profile';
import moment from 'moment';
import initializeApp from './lib/initialization';
import { AppContext } from './context/AppContext';
import { IAppContext } from './context/DefaultAppState';
import { config } from 'dotenv';
import HeaderMenu from './components/header-menu/HeaderMenu';
import { FooterExternal } from './components/footer-external';
import { FooterExternalSub } from './components/footer-external-sub';

import DisplayEnvironment from './components/display-environment/DisplayEnvironment';

config({
  path: `.env.${process.env.NODE_ENV}`
});

//simpra.com => REACT_APP_API_PROD_BASE_URL
//ipd.simpra.com => REACT_APP_API_PROD_BASE_URL
//formulary.simpra.com => REACT_APP_API_PROD_BASE_URL

//https://ipd-dev.logics.cc/#/ => REACT_APP_API_DEV_BASE_URL
//https://formulary-dev.logics.cc/#/ => REACT_APP_API_DEV_BASE_URL
const baseUIUrl = window.location.host;
var baseURL = process.env.REACT_APP_API_DEV_BASE_URL;
switch (baseUIUrl) {
  case 'simpra.com':
  case 'ipd.simpra.com':
  case 'formulary.simpra.com':
    baseURL = process.env.REACT_APP_API_PROD_BASE_URL;
    break;
  default:
    break;
}
axios.defaults.baseURL = baseURL;

const App = (props: any) => {
  const appContext = useContext(AppContext);
  useEffect(() => {
    initialize(appContext);
  }, []);

  const { hash } = useLocation();

  return (
    <>
      <DisplayEnvironment />
      <HashRouter>
        <HeaderMenu />
        <Switch>
          {(appContext.plan && appContext.planState) || hash.includes('/profile') ? <Route path="/profile/:planCode/:recordId/:directory" component={ProfilePage} /> : null}
          {(appContext.plan && appContext.planState) || hash.includes('/results') ? <Route path="/results/:planCode?/:directory?/:specialty?/:name?/:location?" component={ResultsPage} /> : null}
          <Route path="/state-selection" component={StateSelectionPage} />
          <Route path="/" exact component={HomePage} />
        </Switch>
        {/* <div className="footer-container no-print">
          {appContext.planCode ? <div>CMS ID Number: {appContext.planCode}</div> : null}
          <div>Directory Data Updated: {moment(appContext.cacheTime).format('MM/DD/YYYY')}</div>
        </div>
        <FooterExternal />
        <FooterExternalSub /> */}
      </HashRouter>
    </>
  );
};

const initialize = (appContext: IAppContext) => {
  (async () => {
    await initializeApp(appContext);
  })();
};

export default App;
